import React, { useState } from 'react';

export function ResetPasswordModal() {
    const [resetPhone, setResetPhone] = useState('');
    const [Message, setMessage] = useState('');
    const [loading, setLoading] = useState(false); // ← 1. Loading state

    async function handleResetPassword() {
        if (!resetPhone) return;
        setLoading(true); // ← Start loading

        try {
            const response = await fetch(`https://apiv2.mobileartsme.com/resetpass?phonenumber=${resetPhone}&IDService=3566`);
            const result = await response.json();
            
            if (result?.Error === 0) {
                setMessage(result?.result || 'Password reset link sent.');
            } else {
                setMessage(result?.result || 'An error occurred.');
            }
        } catch (error) {
            console.error("Reset password failed:", error);
            setMessage("Failed to send reset request.");
        }finally {
            setLoading(false); // ← End loading
        }
    }
    
    return (
        <div className="modal fade" id="resetPasswordModal" tabIndex="-1" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content p-4">
                    <div className="d-flex flex-column mb-3">
                        <h4>Reset Password</h4>
                        <p>Enter your phone number to reset your password.</p>
                        <input
                            type="text"
                            className="form-control mb-3"
                            placeholder="Phone number"
                            onChange={(e) => setResetPhone(e.target.value)}
                        />
                          <button className="btn btn-warning d-flex align-items-center justify-content-center gap-2" onClick={handleResetPassword} disabled={loading}>
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    <span></span>
                                </>
                            ) : (
                                "Reset Password"
                            )}
                        </button>
                        <p className='text-danger m-0 pt-3' >{Message}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
